var _path, _g, _g2, _g3, _path2, _path3, _g4, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 83,
    viewBox: "0 0 79 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0992 64.576C11.4096 64.576 9.7328 64.4096 8.0688 64.0768C6.4048 63.7696 5.0352 63.3344 3.96 62.7712V56.6656C5.3424 57.3824 6.776 57.92 8.2608 58.2784C9.7712 58.6368 11.2048 58.816 12.5616 58.816C13.816 58.816 14.7632 58.624 15.4032 58.24C16.0432 57.856 16.3632 57.3056 16.3632 56.5888C16.3632 56.0512 16.184 55.5904 15.8256 55.2064C15.4928 54.7968 14.9936 54.4256 14.328 54.0928C13.6624 53.76 12.6256 53.2992 11.2176 52.7104C8.7344 51.6608 6.9296 50.496 5.8032 49.216C4.6768 47.936 4.1136 46.3616 4.1136 44.4928C4.1136 42.9568 4.536 41.5872 5.3808 40.384C6.2512 39.1808 7.4544 38.2464 8.9904 37.5808C10.5264 36.9152 12.2928 36.5824 14.2896 36.5824C15.928 36.5824 17.3872 36.7104 18.6672 36.9664C19.9472 37.2224 21.176 37.632 22.3536 38.1952V44.1472C20.1008 42.9696 17.8352 42.3808 15.5568 42.3808C14.328 42.3808 13.3424 42.5856 12.6 42.9952C11.8832 43.3792 11.5248 43.9424 11.5248 44.6848C11.5248 45.4272 11.896 46.0288 12.6384 46.4896C13.3808 46.9504 14.7504 47.5776 16.7472 48.3712C18.5648 49.1136 19.9728 49.8432 20.9712 50.56C21.9952 51.2768 22.7376 52.1088 23.1984 53.056C23.6592 54.0032 23.8896 55.2064 23.8896 56.6656C23.8896 59.1488 22.9808 61.0944 21.1632 62.5024C19.3712 63.8848 16.6832 64.576 13.0992 64.576ZM33.9867 64.576C32.2971 64.576 30.6203 64.4096 28.9563 64.0768C27.2923 63.7696 25.9227 63.3344 24.8475 62.7712V56.6656C26.2299 57.3824 27.6635 57.92 29.1483 58.2784C30.6587 58.6368 32.0923 58.816 33.4491 58.816C34.7035 58.816 35.6507 58.624 36.2907 58.24C36.9307 57.856 37.2507 57.3056 37.2507 56.5888C37.2507 56.0512 37.0715 55.5904 36.7131 55.2064C36.3803 54.7968 35.8811 54.4256 35.2155 54.0928C34.5499 53.76 33.5131 53.2992 32.1051 52.7104C29.6219 51.6608 27.8171 50.496 26.6907 49.216C25.5643 47.936 25.0011 46.3616 25.0011 44.4928C25.0011 42.9568 25.4235 41.5872 26.2683 40.384C27.1387 39.1808 28.3419 38.2464 29.8779 37.5808C31.4139 36.9152 33.1803 36.5824 35.1771 36.5824C36.8155 36.5824 38.2747 36.7104 39.5547 36.9664C40.8347 37.2224 42.0635 37.632 43.2411 38.1952V44.1472C40.9883 42.9696 38.7227 42.3808 36.4443 42.3808C35.2155 42.3808 34.2299 42.5856 33.4875 42.9952C32.7707 43.3792 32.4123 43.9424 32.4123 44.6848C32.4123 45.4272 32.7835 46.0288 33.5259 46.4896C34.2683 46.9504 35.6379 47.5776 37.6347 48.3712C39.4523 49.1136 40.8603 49.8432 41.8587 50.56C42.8827 51.2768 43.6251 52.1088 44.0859 53.056C44.5467 54.0032 44.7771 55.2064 44.7771 56.6656C44.7771 59.1488 43.8683 61.0944 42.0507 62.5024C40.2587 63.8848 37.5707 64.576 33.9867 64.576ZM55.737 37.1584H62.4186L73.1322 64H66.1818L64.0314 58.4704H54.1242L51.9738 64H44.985L55.737 37.1584ZM62.3418 53.248L59.0778 44.224L55.7754 53.248H62.3418Z",
    fill: "url(#paint0_linear_1349_3871)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1349_3871)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 26,
    r: 2,
    fill: "url(#paint1_linear_1349_3871)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 26,
    r: 2.80841,
    stroke: "white",
    strokeWidth: 1.61682
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1349_3871)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 28,
    r: 1,
    fill: "url(#paint2_linear_1349_3871)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 28,
    r: 1.80841,
    stroke: "white",
    strokeWidth: 1.61682
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1349_3871)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5096,
    cy: 9.50972,
    r: 4,
    transform: "rotate(-31.8995 18.5096 9.50972)",
    fill: "url(#paint3_linear_1349_3871)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5096,
    cy: 9.50972,
    r: 4.80841,
    transform: "rotate(-31.8995 18.5096 9.50972)",
    stroke: "white",
    strokeWidth: 1.61682
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1349_3871",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 74,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5933 14.0564C11.7637 14.0685 11.9268 14.1308 12.0618 14.2355C12.1968 14.3402 12.2979 14.4825 12.3521 14.6445L16.3054 26.5031L18.8309 21.452C18.9027 21.3082 19.0131 21.1873 19.1498 21.1027C19.2865 21.0182 19.444 20.9734 19.6048 20.9734H21.9112C22.1406 20.9734 22.3606 21.0645 22.5228 21.2267C22.685 21.3889 22.7761 21.6089 22.7761 21.8383C22.7761 22.0677 22.685 22.2877 22.5228 22.4499C22.3606 22.6121 22.1406 22.7033 21.9112 22.7033H20.1387L16.9189 29.144C16.8424 29.2969 16.7222 29.4237 16.5737 29.5083C16.4251 29.593 16.2548 29.6317 16.0843 29.6196C15.9137 29.6075 15.7506 29.5452 15.6155 29.4404C15.4804 29.3356 15.3793 29.1932 15.3251 29.031L11.3707 17.1735L8.84516 22.2247C8.77346 22.3683 8.66321 22.4891 8.52675 22.5736C8.3903 22.6581 8.23301 22.703 8.07249 22.7033H5.76604C5.53665 22.7033 5.31666 22.6121 5.15445 22.4499C4.99225 22.2877 4.90112 22.0677 4.90112 21.8383C4.90112 21.6089 4.99225 21.3889 5.15445 21.2267C5.31666 21.0645 5.53665 20.9734 5.76604 20.9734H7.5374L10.7595 14.5326C10.836 14.3796 10.9561 14.2526 11.1047 14.1678C11.2533 14.0831 11.4226 14.0443 11.5933 14.0564Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9158 14.0564C28.0862 14.0685 28.2493 14.1308 28.3843 14.2355C28.5194 14.3402 28.6204 14.4825 28.6746 14.6445L32.6279 26.5031L35.1534 21.452C35.2252 21.3082 35.3357 21.1873 35.4723 21.1027C35.609 21.0182 35.7666 20.9734 35.9273 20.9734H38.2337C38.4631 20.9734 38.6831 21.0645 38.8453 21.2267C39.0075 21.3889 39.0986 21.6089 39.0986 21.8383C39.0986 22.0677 39.0075 22.2877 38.8453 22.4499C38.6831 22.6121 38.4631 22.7033 38.2337 22.7033H36.4612L33.2414 29.144C33.1649 29.2969 33.0447 29.4237 32.8962 29.5083C32.7476 29.593 32.5773 29.6317 32.4068 29.6196C32.2362 29.6075 32.0731 29.5452 31.938 29.4404C31.8029 29.3356 31.7018 29.1932 31.6476 29.031L27.6932 17.1735L25.1677 22.2247C25.096 22.3683 24.9857 22.4891 24.8493 22.5736C24.7128 22.6581 24.5555 22.703 24.395 22.7033H22.0886C21.8592 22.7033 21.6392 22.6121 21.477 22.4499C21.3148 22.2877 21.2236 22.0677 21.2236 21.8383C21.2236 21.6089 21.3148 21.3889 21.477 21.2267C21.6392 21.0645 21.8592 20.9734 22.0886 20.9734H23.8599L27.082 14.5326C27.1585 14.3796 27.2786 14.2526 27.4272 14.1678C27.5759 14.0831 27.7451 14.0443 27.9158 14.0564Z",
    fill: "black"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1349_3871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3792 25.2175C47.9041 28.4637 49.3397 32.2908 52.5858 33.7659C55.8319 35.2409 59.659 33.8053 61.1341 30.5592C62.6092 27.3131 61.1736 23.486 57.9275 22.0109C56.8512 21.5199 55.6604 21.3353 54.486 21.4774L53.8154 17.3526C54.8468 17.0519 55.7587 16.437 56.4241 15.5936C57.0896 14.7502 57.4755 13.7203 57.5281 12.6472C57.5806 11.5742 57.2973 10.5115 56.7175 9.60706C56.1376 8.70264 55.2902 8.00154 54.2932 7.6014C53.2962 7.20126 52.1992 7.12199 51.155 7.37463C50.1108 7.62728 49.1714 8.19926 48.4676 9.01092C47.7637 9.82259 47.3306 10.8335 47.2283 11.903C47.1261 12.9724 47.3599 14.0471 47.8972 14.9774L43.5885 18.4669C42.845 17.8642 41.9048 17.5581 40.949 17.6076C39.9932 17.6571 39.0895 18.0587 38.4123 18.7349C37.735 19.4112 37.3321 20.3142 37.2812 21.27C37.2303 22.2257 37.5351 23.1664 38.1367 23.9108C38.7383 24.6551 39.5941 25.1504 40.5393 25.3011C41.4844 25.4518 42.4519 25.2473 43.2552 24.727C44.0584 24.2067 44.6406 23.4074 44.8895 22.4832C45.1384 21.5591 45.0363 20.5755 44.603 19.7221L48.9117 16.2327C49.3053 16.5865 49.751 16.8778 50.2332 17.0962C50.8562 17.3799 51.5295 17.5369 52.2138 17.558L52.9154 21.872C51.3442 22.4813 50.0745 23.6824 49.3792 25.2175Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1349_3871)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.8753 15.0737C68.2161 14.4803 68.8219 12.9125 68.2284 11.5718C67.635 10.231 66.0672 9.62524 64.7265 10.2187C63.3857 10.8121 62.7799 12.3799 63.3734 13.7206C63.5696 14.1657 63.8848 14.5481 64.2843 14.8256L63.3622 16.2757C62.9632 16.086 62.515 16.0254 62.08 16.1024C61.645 16.1794 61.2448 16.3902 60.9352 16.7053C60.6256 17.0204 60.422 17.4242 60.3527 17.8605C60.2834 18.2969 60.3519 18.7439 60.5486 19.1394C60.7454 19.535 61.0606 19.8593 61.4503 20.0673C61.8401 20.2753 62.285 20.3566 62.7231 20.2998C63.1612 20.243 63.5707 20.0511 63.8945 19.7506C64.2184 19.4502 64.4405 19.0562 64.53 18.6236L66.8074 18.7304C66.8709 19.1188 67.0759 19.4699 67.3829 19.7161C67.69 19.9623 68.0773 20.0861 68.4702 20.0637C68.8631 20.0412 69.2338 19.8741 69.5108 19.5945C69.7878 19.315 69.9515 18.9427 69.9703 18.5496C69.9892 18.1565 69.8618 17.7704 69.6128 17.4656C69.3638 17.1609 69.0107 16.9591 68.6218 16.8992C68.2328 16.8393 67.8354 16.9255 67.5062 17.1412C67.1771 17.357 66.9394 17.6869 66.8391 18.0675L64.5617 17.9607C64.5376 17.7444 64.4804 17.533 64.3921 17.3341C64.2783 17.0766 64.1145 16.8443 63.9102 16.6506L64.8745 15.134C65.5236 15.3766 66.242 15.355 66.8753 15.0737Z",
    fill: "black"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1349_3871)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4,
    y: 4,
    width: 82,
    height: 40,
    fill: "url(#paint4_linear_1349_3871)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1349_3871",
    x: 63.3833,
    y: 20.3833,
    width: 11.2334,
    height: 11.2334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1349_3871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1349_3871",
    x: 69.3833,
    y: 23.3833,
    width: 9.2334,
    height: 9.2334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1349_3871"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1349_3871",
    x: 10.8921,
    y: 1.89209,
    width: 15.2351,
    height: 15.2354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1349_3871"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1349_3871",
    x1: 3,
    y1: 25,
    x2: 87.8433,
    y2: 49.6241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1349_3871",
    x1: 67,
    y1: 24.375,
    x2: 71.7916,
    y2: 25.6112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1349_3871",
    x1: 73,
    y1: 27.1875,
    x2: 75.3958,
    y2: 27.8056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1349_3871",
    x1: 14.5096,
    y1: 6.25972,
    x2: 24.0929,
    y2: 8.73204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#86469C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC98C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1349_3871",
    x1: 37,
    y1: 4,
    x2: 37,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#382D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#643B74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9175A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1349_3871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.9881,
    height: 30.9881,
    fill: "white",
    transform: "translate(72.0317 12.8198) rotate(114.438)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1349_3871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.7425,
    height: 12.7425,
    fill: "white",
    transform: "translate(56.5286 12.686) rotate(-23.8745)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsa);
export default __webpack_public_path__ + "static/media/SSA.d3c1e06c6bf5150ae0ab79c0d166ed9d.svg";
export { ForwardRef as ReactComponent };